import { NarAgentGridData } from "../../../medonc/data-model/medicalPaOrdersModel";
import { logDataToConsole, logError } from "../../../medonc/utils/customLogger";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

export interface AuthGridPayload {
  payer_name: string;
  j_codes: string[];
  client_id: string;
}

export interface AuthGridResponse {
  success: boolean;
  data?: NarAgentGridData[];
  message?: string;
}

export const fetchAuthGridData = async (
  payload: AuthGridPayload,
): Promise<AuthGridResponse> => {
  try {
    logDataToConsole("Making auth grid API call with payload", payload);

    const token = await getBearerToken();

    if (!token) {
      throw new Error("Bearer token not available");
    }

    const response = await fetch(API_ENDPOINTS.FETCH_AUTH_GRID, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      logError(
        new Error(
          `Auth grid API call failed: ${response.status} ${response.statusText}`,
        ),
        errorText,
      );
      return {
        success: false,
        message: `Request failed with status ${response.status}: ${response.statusText}`,
      };
    }
    const responseData = await response.json();
    return {
      success: true,
      data: responseData,
    };
  } catch (error) {
    logError(error as Error, "Error in fetchAuthGridData");
    return {
      success: false,
      message:
        error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
};
